import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ESearchFilters } from '@/constants/searchFilters';
import { applySearchFilter } from '@/redux/modules/search';
import { EFilterMethod, setFormFilter } from '@/redux/modules/searchForm';
import { getQueryParams } from '@/redux/selectors/queryParams';
import { EDeliveryOption } from '@/services/types/core/delivery.types';
import { getPreservedFilters } from '@/utility/modeSwitching';

export const useSearchModes = (onModeSelect?: () => void) => {
  const dispatch = useDispatch();
  const queryParams = useSelector(getQueryParams);

  const handleModeSelect = useCallback(
    (isSwitchingToDelivery: boolean) => {
      const preservedParams = getPreservedFilters(queryParams, isSwitchingToDelivery);

      if (isSwitchingToDelivery) {
        // Apply delivery=true and deliveryStationary=stationary along with preserved filters
        dispatch(
          applySearchFilter(
            {
              ...preservedParams,
              [ESearchFilters.DELIVERY]: 'true',
              [ESearchFilters.DELIVERY_STATIONARY]: EDeliveryOption.STATIONARY,
            },
            false,
            false,
            false,
            undefined,
            true,
          ), // ignoreExistingQueryParams = true to clear all other filters
        );

        dispatch(
          setFormFilter({
            filters: {
              [ESearchFilters.DELIVERY]: true,
              [ESearchFilters.DELIVERY_STATIONARY]: EDeliveryOption.STATIONARY,
            },
            filterMethod: EFilterMethod.INPUT,
          }),
        );
      } else {
        // Apply rentals mode (remove delivery filters) along with preserved filters
        dispatch(
          applySearchFilter(
            {
              ...preservedParams,
              [ESearchFilters.DELIVERY]: undefined,
              [ESearchFilters.DELIVERY_STATIONARY]: undefined,
            },
            false,
            false,
            false,
            undefined,
            true,
          ), // ignoreExistingQueryParams = true to clear all other filters
        );

        dispatch(
          setFormFilter({
            filters: {
              [ESearchFilters.DELIVERY]: undefined,
              [ESearchFilters.DELIVERY_STATIONARY]: undefined,
              [ESearchFilters.DELIVERY_ADDRESS]: undefined,
            },
            filterMethod: EFilterMethod.INPUT,
          }),
        );
      }

      if (onModeSelect) {
        onModeSelect();
      }
    },
    [dispatch, queryParams, onModeSelect],
  );

  return { handleModeSelect };
};
